// src/Routes/AdminRoutes.js
import React, { useContext } from 'react';
import { Routes, Route } from 'react-router-dom';
import {ProtectedComponent} from '../Pages/Authentication';
import {  DonorHome , UpComingDonations } from '../Pages/Donor';
import NotFoundPage from '../Components/NotFoundPage'; 
import { GlobalInfo } from '../Contexts/GlobalContext';
import DonationHistoryDonor from '../Pages/Donor/DonationHistory';

const DonorRoutes = () => {
  const { isSidebarVisible } = useContext(GlobalInfo);
  const { isRestrictedPage  } = useContext(GlobalInfo);

  return (
    <div className={`${!isRestrictedPage ? 'el-middle' : ''}  ${!isSidebarVisible ? 'collapsed-body' : ''}`}>
      <Routes>
        <Route path="dashboard" element={<DonorHome requiredRole="donor" />} />
        <Route path="job-board" element={<DonorHome requiredRole="donor" />} />

        <Route path="upcoming-donations" element={<UpComingDonations requiredRole="donor" />} />


        <Route path="donation-history" element={<DonationHistoryDonor requiredRole="donor" />} />
        {/* <Route path="job-board" element={<DonorHome requiredRole="donor" />} /> */}
        {/* <Route path="upcoming-donations" element={<UpComingDonations requiredRole="donor" />} /> */}
        {/* <Route path="donation-history" element={<DonationHistory requiredRole="donor" />} /> */}
        <Route path="/*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
};

export default DonorRoutes;
